AuthRoute = require 'mixins/authenticated-route'

###
# Список клиентов
###
App.ClientsRoute = Em.Route.extend AuthRoute,

  session: Em.inject.service('session')

  loadRestaurantsFilter: ->
    params = {}
    params.organization_id = @get('session').get('currentOrganization.id')
    @store.filter('restaurant', params, (restaurant) ->
      restaurant.get('organization.id') is params.organization_id
    ).then (v)->
      v.sortBy('city')

  loadOrganizationFilter: ->
    orgs = @get('session.availableOrganizations') || []

    Em.RSVP.resolve orgs.map (organization) =>
      Em.Object.create
        id:  organization.get('id')
        label: organization.get('name')
        checked: false

  beforeModelAuth: ->
     Em.RSVP.hash(
      clientTags: @store.find('client_tag'),
      selectedOrganizations: @loadOrganizationFilter()
      availableRestaurants: @loadRestaurantsFilter()
    ).then (attrs) =>
      controller = @controllerFor('clients')
      controller.setProperties(attrs)
